module.exports = __webpack_public_path__ + "img/frg.9d1c3b5b.png";